import { render, staticRenderFns } from "./ContactsCoAndRegions.vue?vue&type=template&id=9ede8854&scoped=true"
import script from "./ContactsCoAndRegions.vue?vue&type=script&lang=js"
export * from "./ContactsCoAndRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ede8854",
  null
  
)

export default component.exports